import { Helmet } from "react-helmet";

const SEO = ({ text, description }) => {
  const title = `${text} | Online JavaScript Practice Ground | Learnersbucket`;
  const url = window.location.href;
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      <meta
        property="og:image"
        content="https://learnersbucket.com/wp-content/uploads/2021/10/Cropped-Screen-Shot.png"
      />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta
        property="twitter:image"
        content="https://learnersbucket.com/wp-content/uploads/2021/10/Cropped-Screen-Shot.png"
      />
    </Helmet>
  );
};

export default SEO;
